import { render } from "./mallSetting.vue?vue&type=template&id=dff90b16&scoped=true"
import script from "./mallSetting.vue?vue&type=script&lang=js"
export * from "./mallSetting.vue?vue&type=script&lang=js"

import "./mallSetting.vue?vue&type=style&index=0&id=dff90b16&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff90b16"]])

export default __exports__